<template>
  <div class="h-full flex flex-col" v-if="design !== null">
    <h1 class="text-4xl mb-5">
      {{ design.title }} - <small>{{ design.type }}</small>
    </h1>
    <ImageLightbox ref="imageLightbox" :images="design.promo_images" />
    <div id="page" @scroll="$bus.$emit('scroll')" class="content flex-grow">
      <div id="d-description" class="section">
        <div class="scale-grid flex max-h-50 flex-row flex-wrap items-start">
          <tile
            class="w-full full"
            :key="design.banner_image.url"
            :image="design.banner_image.url"
            :scale="false"
            :info="false"
            move-on-mouse-over
          />
        </div>
        <div class="scale-grid flex max-h-50 flex-row flex-wrap items-start">
          <tile
            :class="{
              'w-full': mobile,
              'w-1/3': !mobile,
              'order-last': mobile,
            }"
            :margin="false"
            :scale="false"
            :info="false"
          >
            <image-slides
              slot="tile-content"
              class="w-full h-full overflow-hidden"
              :images="design.promo_images"
              :lightbox="index => $refs.imageLightbox.open(index)"
            ></image-slides>
          </tile>
          <div
            :class="{
              'w-full': mobile,
              'w-2/3': !mobile,
              'px-3 flex h-full pb-6': true,
            }"
          >
            <div class="tile-content">
              <p class="fill-content">{{ design.description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div id="d-details" class="section">
        <div class="scale-grid flex max-h-50 flex-row flex-wrap items-start">
          <tile
            :class="[mobile ? 'w-full' : 'w-1/3']"
            v-for="(img, index) in design.detail_images"
            :key="img.url"
            :image="img.url"
            @click="() => $refs.detailLightbox.open(index)"
            :info="false"
          />
        </div>
        <ImageLightbox ref="detailLightbox" :images="design.detail_images" />
        <div class="scale-grid flex max-h-50 flex-row flex-wrap items-start">
          <div
            :class="{
              'w-full mb-6': mobile,
              'w-1/3': !mobile,
              'px-3 tile-content-slot': true,
            }"
          >
            <h2 class="text-xl">Team</h2>
            <ul class="list-disc pl-5">
              <li v-for="p in design.team_members">{{ p.name }} - {{ p.role }}</li>
            </ul>
          </div>
          <div :class="[mobile ? 'w-full' : 'w-2/3', 'px-3 flex h-full pb-6']">
            <div class="tile-content">
              <div class="fill-content mb-3">
                <div class="flex flex-row" :class="['flex', mobile ? 'flex-col' : 'flex-row']">
                  <div class="flex-grow">
                    <h2 class="text-xl">Details</h2>
                    <ul class="list-disc pl-5">
                      <li v-for="d in design.details">
                        {{ d.value }}
                      </li>
                    </ul>
                  </div>
                  <div v-if="design.is_for_sale" :class="[mobile ? 'text-left mt-6' : 'text-right']">
                    <h2 class="text-xl">Price</h2>
                    <h2>
                      <span v-if="design.price_varies">
                        Varies
                      </span>
                      <span v-else> €{{ design.price }} </span>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button
      v-if="design.is_for_sale && design.payment_url"
      @click="openSale"
      class="action-btn self-end w-full bg-white-25 hover:bg-dm py-2 rounded-full"
    >
      Buy Now
    </button>
    <button v-else disabled="disabled" class="action-btn self-end w-full bg-white-25 opacity-50 py-2 rounded-full ">
      Not for Sale
    </button>
  </div>
</template>

<script>
import SingleImage from '@components/details/SingleImage';
import ImageSlides from '@components/details/ImageSlides';
import Icon from '@components/Icon';
import Tile from '@components/Tile';
import ImageLightbox from '@components/ImageLightbox';

export default {
  name: 'design-details',
  components: { ImageSlides, SingleImage, Icon, Tile, ImageLightbox },
  data() {
    return {
      design: null,
      loading: true,
      mobile: this.$store.state.screenSize === 1,
    };
  },
  mounted() {
    if (!this.$route.params.design) {
      this.getDesign(this.$route.params.slug)
        .then(({ data }) => {
          this.design = data;
          this.loading = false;
        })
        .catch(e => {
          if (e.response.status === 404) {
            this.$router.push('/404');
          }
        });
    } else {
      this.design = this.$route.params.design;
      this.loading = false;
    }

    this.$bus.$on('prev', () => {
      this.$router.push({
        name: `design-detail`,
        params: { slug: this.design.nav.prev },
      });
    });

    this.$bus.$on('next', () => {
      this.$router.push({
        name: `design-detail`,
        params: { slug: this.design.nav.next },
      });
    });

    this.$bus.$on('back', () => {
      this.$router.push({
        name: 'design',
      });
    });
  },

  watch: {
    '$store.state.screenSize': function(size) {
      this.mobile = size === 1;
    },
  },

  beforeDestroy() {
    this.$bus.$off('prev');
    this.$bus.$off('next');
    this.$bus.$off('back');
  },

  methods: {
    openSale() {
      this.goTo(this.design.payment_url);
    },
    getDesign(slug) {
      return window.axios.get(`/api/designs/${slug}`);
    },
  },
};
</script>

<style scoped>
#router-cont {
  padding-bottom: 7.5rem !important;
}
</style>
